const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2200 1466",
    style: {
      enableBackground: "new 0 0 2200 1466"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2200,
    height: 1466
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD7DB"
    },
    d: "M1005.738,423.015c14.661,5.911,24.262,20.135,24.262,35.943v146.256 c0,418.884-329.329,563.141-400.366,589.385c-8.651,3.196-18.151,3.196-26.801,0c-71.037-26.244-400.366-170.501-400.366-589.385 V458.957c0-15.808,9.601-30.031,24.262-35.943l375.013-151.203c9.298-3.749,19.686-3.749,28.984,0L1005.738,423.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACBBBF"
    },
    d: "M1030,458.955v146.258c0,418.883-329.331,563.138-400.365,589.384 c-4.326,1.604-8.868,2.403-13.402,2.403V269.002c4.925,0,9.85,0.934,14.496,2.81l375.005,151.199 C1020.397,428.926,1030,443.15,1030,458.955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#235644"
    },
    d: "M968.245,477.542c0,0,0,55.115,0,146.683c0,399.446-352.012,505.349-352.012,505.349 s-352.011-105.904-352.011-505.349c0-91.568,0-146.683,0-146.683l352.011-141.929L968.245,477.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B3F31"
    },
    d: "M968.241,477.546c0,0,0,55.109,0,146.681c0,399.447-352.008,505.347-352.008,505.347V335.613 L968.241,477.546z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M786.35,686.248c-3.884,61.26-31.556,122.86-81.789,158.126 c-48.707,34.191-132.403,47.965-203.421,28.782c-2.726,9.495-7.053,24.038-10.757,37.61 c-3.405,12.497-16.645,19.558-28.927,15.438c-0.243-0.083-0.486-0.166-0.728-0.257c-11.922-4.064-18.094-17.214-13.767-29.045 c6.63-18.129,14.398-38.63,20.508-53.104c12.574-29.773,27.103-58.534,45.614-84.979 c39.788-56.849,83.523-89.376,110.217-105.577c1.782-1.082,0.347-3.801-1.554-2.934 c-42.049,19.197-118.352,66.032-167.191,162.128c-12.74-41.203-11.429-86.852,4.91-126.82 c22.158-54.193,69.021-95.327,121.043-122.187c46.349-23.927,97.005-37.826,147.695-50.455 c10.944-2.726,22.214,2.927,26.583,13.316C776.141,577.016,789.824,631.514,786.35,686.248z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD7DB"
    },
    d: "M1973.272,423.015c14.661,5.911,24.262,20.135,24.262,35.943v146.256 c0,418.884-329.329,563.141-400.366,589.385c-8.651,3.196-18.151,3.196-26.801,0C1499.329,1168.354,1170,1024.097,1170,605.213 V458.957c0-15.808,9.601-30.031,24.262-35.943l375.013-151.203c9.298-3.749,19.686-3.749,28.984,0L1973.272,423.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACBBBF"
    },
    d: "M1997.534,458.955v146.258c0,418.883-329.331,563.138-400.365,589.384 c-4.326,1.604-8.868,2.403-13.402,2.403V269.002c4.925,0,9.85,0.934,14.496,2.81l375.005,151.199 C1987.931,428.926,1997.534,443.15,1997.534,458.955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0291F8"
    },
    d: "M1935.778,477.542c0,0,0,55.115,0,146.683c0,399.446-352.011,505.349-352.011,505.349 s-352.011-105.904-352.011-505.349c0-91.568,0-146.683,0-146.683l352.011-141.929L1935.778,477.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2364CC"
    },
    d: "M1935.775,477.546c0,0,0,55.109,0,146.681c0,399.447-352.008,505.347-352.008,505.347V335.613 L1935.775,477.546z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1753.884,686.248c-3.884,61.26-31.556,122.86-81.789,158.126 c-48.707,34.191-132.403,47.965-203.421,28.782c-2.726,9.495-7.053,24.038-10.757,37.61 c-3.405,12.497-16.645,19.558-28.927,15.438c-0.243-0.083-0.485-0.166-0.728-0.257c-11.922-4.064-18.094-17.214-13.767-29.045 c6.63-18.129,14.398-38.63,20.508-53.104c12.574-29.773,27.103-58.534,45.614-84.979 c39.788-56.849,83.523-89.376,110.217-105.577c1.782-1.082,0.347-3.801-1.553-2.934 c-42.049,19.197-118.352,66.032-167.191,162.128c-12.74-41.203-11.43-86.852,4.91-126.82 c22.159-54.193,69.021-95.327,121.043-122.187c46.349-23.927,97.005-37.826,147.695-50.455 c10.944-2.726,22.214,2.927,26.583,13.316C1743.675,577.016,1757.358,631.514,1753.884,686.248z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.448bfe7189da44c5b690ce3dad60f867.svg";
export { ForwardRef as ReactComponent };